import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import { screenSizes } from '@libs/theme';
import { useAssetUrlByJurisdiction, useDimensions } from '@libs/hooks';
import Typography from '../typography/Typography';
import { BankWireCheckPoints, CheckPoint, CheckPointFirstLine, Gradient, BankWireCheckPointsContainer, StepsWrapper, CheckPointTitleWrapper, TitleWrapper, BankWireImagesContainer, BankWireImageContainer, ButtonWrapper, CustomButton, CheckPointsContainerWrapper, CustomTitleTypography, BankWireImageWrapper, MobileGradient, MobileGradientRight, StepsTitleTypography, GradientTop, CustomArrowIcon, BankWireImage, PageWrapper, FaqSteps, } from './styles';
const DepositWithdrawSteps = ({ imagesArray, imagesArrayLength, stepTitles, title, MobileFrameImage, containerWidth, className, imageBackgroundWidth, }) => {
    const { colors } = useTheme();
    const [step, setStep] = useState(0);
    const activeStepRef = useRef(null);
    const containerRef = useRef(null);
    const { width } = useDimensions();
    const isMobile = width < screenSizes.tablet;
    const firstStep = step <= 4;
    const lastStep = step >= 4;
    const disabledLeftButton = step === 0;
    const disabledRightButton = step === imagesArrayLength;
    useEffect(() => {
        if (activeStepRef.current && containerRef.current && isMobile) {
            const inlineValue = step === imagesArrayLength ? 'nearest' : 'center';
            activeStepRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: inlineValue,
            });
        }
    }, [imagesArrayLength, isMobile, step]);
    useEffect(() => {
        if (activeStepRef.current && containerRef.current && !isMobile) {
            const nextStepRef = activeStepRef.current.nextElementSibling;
            const previousStepRef = activeStepRef.current.previousElementSibling;
            if (previousStepRef) {
                previousStepRef.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                });
            }
            else {
                containerRef.current.scrollBy({
                    top: -40,
                    behavior: 'smooth',
                });
            }
            if (nextStepRef) {
                nextStepRef.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                });
            }
            else {
                containerRef.current.scrollBy({
                    top: 40,
                    behavior: 'smooth',
                });
            }
        }
    }, [isMobile, step]);
    const increaseStep = () => {
        setStep((prevStep) => Math.min(prevStep + 1, imagesArrayLength));
    };
    const decreaseStep = () => {
        setStep((prevStep) => Math.max(prevStep - 1, 0));
    };
    const currentImageLink = useAssetUrlByJurisdiction(imagesArray[step]);
    return (_jsxs(PageWrapper, { className: className, children: [_jsx(CustomTitleTypography, { type: "bodyButton", fontFamily: "primaryBold", color: colors.text.default, children: title }), _jsxs(StepsWrapper, { children: [_jsx(CheckPointsContainerWrapper, { children: _jsxs(BankWireCheckPointsContainer, { ref: containerRef, containerWidth: containerWidth, children: [_jsx(GradientTop, { firstStep: firstStep }), _jsx(Gradient, { lastStep: lastStep }), _jsx(MobileGradient, { firstStep: firstStep }), _jsx(MobileGradientRight, { lastStep: lastStep }), _jsx(FaqSteps, { children: stepTitles.map((item, i) => {
                                        const ref = i === step ? activeStepRef : null;
                                        const backgroundColor = step === i
                                            ? colors.interactive.brandColor
                                            : colors.borders.default;
                                        const borderColor = step === i ? colors.surface.default : colors.borders.default;
                                        const fontFamily = step === i ? 'primaryBold' : 'primary';
                                        const color = step === i
                                            ? colors.interactive.brandColor
                                            : colors.text.secondary;
                                        return (_jsxs(CheckPointTitleWrapper, { ref: ref, children: [_jsxs(BankWireCheckPoints, { children: [_jsx(CheckPoint, { backgroundColor: backgroundColor, borderColor: borderColor, onClick: () => setStep(i) }, i), _jsx(CheckPointFirstLine, { backgroundColor: backgroundColor }, `line-${i}`)] }), _jsxs(TitleWrapper, { onClick: () => setStep(i), children: [_jsx(StepsTitleTypography, { type: "bodyButton", fontFamily: fontFamily, color: color, children: item.number }), _jsx(StepsTitleTypography, { type: "bodyButton", fontFamily: fontFamily, color: color, children: item.title })] })] }, i));
                                    }) })] }) }), _jsxs(BankWireImagesContainer, { children: [_jsx(BankWireImageWrapper, { imageBackgroundWidth: imageBackgroundWidth, children: _jsx(BankWireImageContainer, { MobileFrameImage: MobileFrameImage, className: "bankwire-image-container", children: _jsx(BankWireImage, { currentImage: currentImageLink }) }) }), _jsx(Typography, { type: "subHeadline", fontFamily: "primaryBold", children: stepTitles[step].title }), _jsxs(ButtonWrapper, { children: [_jsx(CustomButton, { onClick: decreaseStep, buttonType: "secondary", icon: _jsx(CustomArrowIcon, { leftIcon: true }), disabled: disabledLeftButton }), _jsx(CustomButton, { onClick: increaseStep, buttonType: "secondary", icon: _jsx(CustomArrowIcon, {}), disabled: disabledRightButton })] })] })] })] }));
};
export default DepositWithdrawSteps;
//# sourceMappingURL=DepositWithrdawSteps.js.map